module.exports = {
    NEW_PROJECT_CLASS: '.js-new-project',
    TEMPLATE_PROJECT_CLASS: '.js-template-project',
    OPEN_PROJECT_CLASS: '.js-open-project',
    SAVE_PROJECT_CLASS: '.js-save-project',
    PROJECT_SETTINGS_CLASS: '.js-project-settings',

    LAYOUT_MANUAL: '.js-manual-button',
    LAYOUT_TREE: '.js-tree-button',
    LAYOUT_CLUSTER: '.js-cluster-button',

    EXPORT_TO_PNG: '.js-export-to-png',
    EXPORT_TO_SVG: '.js-export-to-svg',
    EXPORT_TO_PDF: '.js-export-to-pdf',

    UNDO: '.js-undo',
    REDO: '.js-redo',
    HELP: '.js-nav-help',

    // HORIZONTAL_MARGIN: '#hor-margin',
    // VERTICAL_MARGIN: '#ver-margin',
    MAX_EDGE: '#max-edge',
    WIDTH_SIZE: '#width-size',
    HEIGHT_SIZE: '#height-size',

    VARIABLES: '.js-open-variables',
    SENSITIVITY: '.js-open-sensitivity',
    RECALCULATE: '.js-recalculate-layout',
};



// WEBPACK FOOTER //
// ./scripts/components/constants/class.js